import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router'

import { PROFILE_OVERVIEW, ROOMMATE_PROFILE } from 'constants/urls'
import { profilePageTitleSelector } from 'redux/selectors/ProfileSelectors'

export const usePageTitle = () => {
  // For demo purposes we set title only for profile page page
  const isProfileOverviewPage = useRouteMatch(PROFILE_OVERVIEW)
  const isRoommateProfilePage = useRouteMatch(ROOMMATE_PROFILE)
  const profilePageTitle = useSelector(profilePageTitleSelector)

  // Don't set a title for roommate profile pages
  if (isRoommateProfilePage?.isExact) {
    return null
  }

  return isProfileOverviewPage?.isExact && profilePageTitle
}
